import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Card, CardHeader, CardBody, Form, Input, FormGroup, Button } from 'reactstrap';
import { useUser } from 'context';
import AlertModal from 'components/AlertModal';
import { Label } from 'recharts';
import { useForm } from 'hooks/useForm';
import { requestCertificate } from 'features/paperwork/certificadoAPI';
import { useAlertPlus } from 'hooks';

interface FormValues {
  target: string;
  reason: string;
}

export default function CertificadoEticaRequest() {
  const { getMatricula } = useUser();
  const history = useHistory();

  const [values, handleChange] = useForm<FormValues>({
    target: '',
    reason: '',
  });

  const [showAlert, message, alertCallback, alert] = useAlertPlus('');

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const submit = () => {
    const matricula = getMatricula();
    if (!matricula) {
      console.error('No se pudo obtener la matrícula del usuario');
      return;
    }

    setIsLoading(true);

    requestCertificate({ matricula: parseInt(matricula), ...values })
      .then(response => {
        setIsSuccess(true);
        alert(`Se realizó el pedido con el número de trámite #${ response.id }`);
      })
      .catch(err => {
        setIsSuccess(false);
        console.error(err);
        alert(
          err?.message ??
          'Ocurrió un error inesperado al obtener el certificado de praxis médica.',
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const redirectAfterSuccess = () => {
    if (!isSuccess) {
      alertCallback();
      return;
    }

    history.push('/tramites/certificado-etica');
  };

  return (
    <div className="content">
      <AlertModal isOpen={ showAlert } message={ message } onClose={ redirectAfterSuccess } />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>Solicitar Certificado de Ética</Col>
                <Col md={4} className="text-right">
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Form role="form">
                <FormGroup className="mb-3">
                  <Label>Entidad ante la que será presentado el certificado</Label>
                  <Input
                    placeholder="Ingresar entidad..."
                    name="target"
                    type="text"
                    value={ values.target }
                    onChange={ handleChange }
                    disabled={ isLoading }
                  />
                </FormGroup>
                <FormGroup className="mb-3">
                  <Label>Motivo por el cual se está solicitando</Label>
                  <Input
                    placeholder="Ingresar motivo..."
                    name="reason"
                    type="text"
                    value={ values.reason }
                    onChange={ handleChange }
                    disabled={ isLoading }
                  />
                </FormGroup>
                <p>
                  De conformidad con la normativa institucional vigente, la expedición del Certificado de Ética se
                  encuentra supeditada al cumplimiento regular de las obligaciones colegiales. En caso de registrarse
                  mora en el pago de la matrícula, multa, intereses o cualquier otro concepto administrativo, el
                  trámite no podrá ser procesado hasta la total regularización del estado de su cuenta corriente.
                </p>
                <div className="text-center">
                  <Button
                    className="mt-2 mb-3"
                    color="primary"
                    type="button"
                    onClick={ submit }
                    disabled={ isLoading }
                  >
                    Solicitar
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
